import {
  ButtonBase,
  Hidden,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import React from 'react'

import { gregorianToJalaali } from '../../helpers/date'
import { persianRegex } from '../../helpers/regex'
import { lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { Contract } from '../../types/contract'
import useStyles from './styles/ContractsTable.styles'

interface ContractRowProps {
  data: Contract
  providerCode: string
  providerID: string
  templateID: string
}

const ContractRow: React.FC<ContractRowProps> = ({
  data,
  providerCode,
  providerID,
  templateID
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const { Title, ID } = data

  const isPersian = persianRegex.test(Title)

  return (
    <ButtonBase
      className={[
        classes.tableRow,
        isSmallScreen ? classes.tableRowForSmallScrren : ''
      ].join(' ')}
      component={LocalizedLink}
      to={`/contracts/provider/${providerCode}/${providerID}/template/${templateID}/contract/${ID}`}>
      <div className={classes.nameCell}>
        <Typography
          variant="h4"
          style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
          {Title}
        </Typography>
      </div>
      <Hidden smDown>
        <div className={classes.nameCell}>
          <Tooltip
            placement="top-end"
            title={
              data.Channels.length > 1
                ? `${data.Channels.map((ch) => ch.DisplayChannelCode).join(
                    ' ,'
                  )}`
                : ''
            }>
            <Typography variant="h4">
              {data.Channels.length > 1
                ? data.Channels.map((ch) => ch.DisplayChannelCode)
                    .join(' ,')
                    .toString()
                    .slice(0, 15) + ' ...'
                : data.Channels.map((ch) => ch.DisplayChannelCode).join(' ,')}
            </Typography>
          </Tooltip>
        </div>
        <div className={classes.nameCell}>
          <Typography variant="h4">
            {data.Accommodations.map((acc) =>
              data.Accommodations.length > 1
                ? acc.DisplayPropertyCode + ' , '
                : acc.DisplayPropertyCode
            )}
          </Typography>
        </div>
        <div className={classes.nameCell}>
          <Typography variant="h4">
            {(lang === 'en' ? data.From : gregorianToJalaali(data.From)) +
              ' => ' +
              (lang === 'en' ? data.To : gregorianToJalaali(data.To))}
          </Typography>
        </div>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.Active ? 'Yes' : 'No'}</Typography>
        </div>
        {!isSmallScreen && (
          <div className={classes.editButtonContainer}>
            <Typography variant="body1">
              <EditIcon />
            </Typography>
          </div>
        )}
      </Hidden>
      {isSmallScreen && (
        <div className={classes.editButtonContainer}>
          <Typography variant="body1">
            <EditIcon className={classes.EditIcon} />
          </Typography>
        </div>
      )}
    </ButtonBase>
  )
}

export default ContractRow
